export var ErrorTypes = {
  ABORT: 'ABORT',
  TIMEOUT: 'TIMEOUT'
};
export var ErrorMessages = {
  INVALID_JSON_STRING: 'Received an invalid JSON string',
  INVALID_ORGANIZATION: 'You did not set a valid organization. Call `flow.client.setOrganization()` with your organization.',
  NETWORK_ERROR: 'A network error has occurred while processing your request. Please try again.',
  REQUEST_TIMEDOUT: 'A network error has occurred, request timed out. Please try again.'
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/web-sdk/dist/esm/constants.js
// module id = 332
// module chunks = 0 1